var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',{staticClass:"blue-grey--text text--lighten-1"},[_vm._v(_vm._s(_vm.item.title))]),_c('span',{staticStyle:{"font-size":"15px"},domProps:{"innerHTML":_vm._s(_vm.item.content)}})])}
var staticRenderFns = []

export { render, staticRenderFns }